// extracted by mini-css-extract-plugin
export default {"stageCell":"ApplicantAnalysis_stageCell__6SR-c"};